import React from 'react';
import { MapPin, Clock, Phone, ExternalLink } from 'lucide-react';
import { Button } from '../ui/button';
import { companyInfo } from '../../data/mock';

const LocationSection = () => {
  const whatsappLink = `https://wa.me/55${companyInfo.whatsapp}?text=Olá! Gostaria de saber como chegar na loja.`;
  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(companyInfo.fullAddress)}`;

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#2B3990] mb-4">
              Nossa Localização em Osasco
            </h2>
            <p className="text-gray-600">
              Estamos localizados no centro de Osasco, com fácil acesso e estacionamento próximo.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Map */}
            <div className="bg-gray-100 rounded-2xl overflow-hidden h-[400px]">
              <iframe
                src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${encodeURIComponent(companyInfo.fullAddress)}`}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Localização Tsw Info"
              ></iframe>
            </div>

            {/* Info */}
            <div className="flex flex-col justify-center">
              <div className="space-y-6">
                <div className="flex items-start gap-4 p-6 bg-gray-50 rounded-xl">
                  <div className="w-12 h-12 bg-[#2B3990] rounded-lg flex items-center justify-center flex-shrink-0">
                    <MapPin size={24} className="text-[#8DC63F]" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#2B3990] mb-1">Endereço</h3>
                    <p className="text-gray-600">{companyInfo.address}</p>
                    <p className="text-gray-600">{companyInfo.neighborhood}, {companyInfo.city} - {companyInfo.state}</p>
                  </div>
                </div>

                <div className="flex items-start gap-4 p-6 bg-gray-50 rounded-xl">
                  <div className="w-12 h-12 bg-[#2B3990] rounded-lg flex items-center justify-center flex-shrink-0">
                    <Clock size={24} className="text-[#8DC63F]" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#2B3990] mb-1">Horário de Funcionamento</h3>
                    <p className="text-gray-600">Segunda a Sexta-feira</p>
                    <p className="text-gray-600 font-medium">{companyInfo.hours}</p>
                  </div>
                </div>

                <div className="flex items-start gap-4 p-6 bg-gray-50 rounded-xl">
                  <div className="w-12 h-12 bg-[#2B3990] rounded-lg flex items-center justify-center flex-shrink-0">
                    <Phone size={24} className="text-[#8DC63F]" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#2B3990] mb-1">Contato</h3>
                    <p className="text-gray-600">WhatsApp: {companyInfo.whatsappFormatted}</p>
                    <p className="text-gray-600">{companyInfo.email}</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <a href={mapsUrl} target="_blank" rel="noopener noreferrer" className="flex-1">
                    <Button variant="outline" className="w-full border-[#2B3990] text-[#2B3990] hover:bg-[#2B3990] hover:text-white">
                      <ExternalLink size={18} className="mr-2" />
                      Ver no Google Maps
                    </Button>
                  </a>
                  <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="flex-1">
                    <Button className="w-full bg-[#8DC63F] hover:bg-[#7ab635] text-white">
                      <Phone size={18} className="mr-2" />
                      Como Chegar?
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;